import { view, utils } from '@yola/ws-sdk';
import { targetClasses } from 'src/js/modules/element-settings/constants/target-classes';
import controlUnits from '../constants/control-units';

const SUPPORTED_UNITS = [controlUnits.PX];

const TARGET_TO_CSS_PROPERTY = {
  [targetClasses.PADDING_TOP]: 'padding-top',
  [targetClasses.PADDING_BOTTOM]: 'padding-bottom',
  [targetClasses.COL_PADDING_LEFT]: 'padding-left',
  [targetClasses.COL_PADDING_RIGHT]: 'padding-right',
  [targetClasses.COLS_GAP_X]: 'column-gap',
  [targetClasses.GAP_Y]: 'row-gap',
};

const TARGET_TO_FALLBACK_VALUE = {
  [targetClasses.PADDING_TOP]: '32px',
  [targetClasses.PADDING_BOTTOM]: '32px',
  [targetClasses.COL_PADDING_LEFT]: '40px',
  [targetClasses.COL_PADDING_RIGHT]: '40px',
  [targetClasses.COLS_GAP_X]: '30px',
  [targetClasses.GAP_Y]: '48px',
};

const computeSpacingFallback = ({ elementId, target }) => {
  const element = view.accessors.getLiveElement(elementId);
  const fallbackValue = TARGET_TO_FALLBACK_VALUE[target];

  if (!element) {
    return fallbackValue;
  }

  const computedValue = getComputedStyle(element)
    .getPropertyValue(TARGET_TO_CSS_PROPERTY[target])
    ?.trim();
  const parsedValue = parseFloat(computedValue);

  if (!utils.isNumeric(parsedValue) || parsedValue <= 0) {
    return fallbackValue;
  }

  const unit = SUPPORTED_UNITS.find((item) => computedValue?.endsWith(item));
  const hasSupportedUnit = Boolean(unit);

  if (!hasSupportedUnit) {
    return fallbackValue;
  }

  return `${parsedValue}${unit}`;
};

export default computeSpacingFallback;
